<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    :vid="id"
    :rules="rules"
    mode="passive"
  >
    <b-form-group :label="label" :label-for="id">
      <v-select
        :options="options"
        :name="name"
        :dir="isRTL"
        :id="id"
        :loading="loading"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{ 'has-error': errors.length > 0 && !$attrs.value }"
      >
        <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
          <slot :name="name" v-bind="data"></slot>
        </template>
        <template #no-options> لا يوجد نتائج لعرضها </template>
        <template v-if="working" #spinner="{ working }">
          <b-spinner
            small
            variant="primary"
          ></b-spinner> </template
      >
      <template v-else #spinner="{ loading }">
          <b-spinner
            small
            variant="primary"
            v-if="loading"
          ></b-spinner> </template
      >
    </v-select>
      <small class="text-danger" v-if="errors.length > 0 && !$attrs.value ">
        <span v-if="!errors[0].includes('field')">{{ errors[0] }}</span>
        <span v-else="!errors[0].includes('field')">هذا الحقل مطلوب</span>
      </small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import { BFormGroup, BSpinner } from "bootstrap-vue";
import store from "./store";
import { $themeConfig } from "@themeConfig";
import { required } from "@validations";

export default {
  components: {
    ValidationProvider,
    vSelect,
    BSpinner,
    BFormGroup,
  },
  props: {
    id: {
      type: String,
      default: () => "select",
    },
    working: {
      type: Boolean,
      default: () => false,
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    ep: {
      type: String,
      default: () => null,
    },
    dataPath: {
      type: String,
      default: () => "data",
    },
  },
  data() {
    return {
      required,
    };
  },
  computed: {
    isRTL() {
      return $themeConfig.layout.isRTL ? "rtl" : "ltr";
    },
    options() {
      return this.$store.getters[`${this.id}/options`] || this.$attrs.options;
    },
    loading() {
      return this.$store.getters[`${this.id}/loading`];
    },
    defaultName() {
      return this.name || this.label;
    },
  },
  methods: {
    async refreshOptions(val) {
      if (this.$store.hasModule(this.id)) {
        await this.$store
          .dispatch(`${this.id}/fetchOptions`, {
            ep: val || this.ep,
            path: this.dataPath,
          })
          .then(() => {
            this.$emit("optionsFetched");
            
          });
      }
    },
  },
  created() {
    if (this.ep && !this.$attrs.options && !this.$store.hasModule(this.id)) {
      this.$store.registerModule(this.id, store);
      if (this.ep.length > 1) {
        this.$store
          .dispatch(`${this.id}/fetchOptions`, {
            ep: this.ep,
            path: this.dataPath,
          })
          .then(() => {
            this.$emit("optionsFetched");
          });
      }
    }
  },
  beforeDestroy() {
    if (this.$store.hasModule(this.id)) {
      if (!this.id.includes(".")) this.$store.unregisterModule(this.id);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.has-error {
  .vs__dropdown-toggle {
    border: 1px solid #ea5455 !important;
  }
}

.vs__dropdown-toggle {
  background-color: var(--white);
}
</style>
